import TeamBodyResults from "./teamBodyResults/teamBodyResults";
import MiddleBodyResults from "./middleBodyResults/middleBodyResults";
import "./bodyResults.sass";

export default function BodyResults({ data }) {

  const { left_class, left_image, left_name, left_score,
    right_class, right_image, right_name, right_score,
    utc_date
  } = data;

  return (
    <div className="results__body">
      <TeamBodyResults left_image={left_image} left_name={left_name} position='left' />
      <MiddleBodyResults date={utc_date} left_class={left_class} right_class={right_class} clase={data.class} left_score={left_score} right_score={right_score} />
      <TeamBodyResults right_image={right_image} right_name={right_name} position='right' />
    </div>
  )
}
